import "@/services/firstNames.js";
import "@/services/lastNames.js";
import shuffleInplace from "fisher-yates/inplace";
import {
    createPlayer,
  } from "./APIService";


const sample = require("lodash.sample");

export async function generateRobots(gameCode, id, count, store) {
    shuffleInplace(firstNames);
    shuffleInplace(lastNames);

    for (let i = 1; i <= count; i++) {
        const firstName = firstNames.pop();
        const lastName = lastNames.pop();

        await createPlayer(
            firstName,
            lastName,
            firstName,
            firstName + "@robot.notreal",
            id,
            gameCode,
            false,
            true
        ).then(resp => {
            store.dispatch("log", "New robot created: " + firstName + " " + lastName);
        });
    }
    return Promise.resolve();
}
